export default __webpack_public_path__ + "static/media/thumbnail.c85bc1e4.png";